import YMaps, { getMapWorkingTime, getMapPhoneNumber } from './index';
import Popup from '../base/Popup';

import '../../images/sprite/cross.svg';
import '../../images/sprite/clock.svg';

// Используем png, так как сборщик не может нормально собрать SVG ;(
import placemarkPath from '../../images/frontend/placemark.png';
import placemarkActivePath from '../../images/frontend/placemark-active.png';
import placemarkEmptyPath from '../../images/frontend/placemark-empty.png';
import placemarkEmptyActivePath from '../../images/frontend/placemark-empty-active.png';

window.Popup = Popup;

// Фикс иконок для разных типов сборок webpack
const getPlacemarkIcon = placemarkPathRaw => {
    if (typeof placemarkPathRaw === 'string') {
        return placemarkPathRaw.replace(/^"|"$/g, '');
    }

    return placemarkPathRaw.src;
};

const placemarkIcon = getPlacemarkIcon(placemarkPath);
const placemarkIconActive = getPlacemarkIcon(placemarkActivePath);
const placemarkEmptyIcon = getPlacemarkIcon(placemarkEmptyPath);
const placemarkEmptyIconActive = getPlacemarkIcon(placemarkEmptyActivePath);

// Параметры меток и кластеров
const iconSize = [26, 32];
const iconOffset = [-13, -32];
const placemarkIcons = [
    {
        href: placemarkIcon,
        size: iconSize,
        offset: iconOffset,
    },
    {
        href: placemarkIconActive,
        size: iconSize,
        offset: iconOffset,
    },
];
const clusterCSS = 'color: #fff; padding-left: 2px; text-align: center; font: bold 14px/28px Futura, Arial, sans-serif';
const clusterIcons = [
    [
        {
            href: placemarkEmptyIcon,
            size: iconSize,
            offset: iconOffset,
        },
        {
            href: placemarkEmptyIcon,
            size: iconSize,
            offset: iconOffset,
        },
    ],
    [
        {
            href: placemarkEmptyIconActive,
            size: iconSize,
            offset: iconOffset,
        },
        {
            href: placemarkEmptyIconActive,
            size: iconSize,
            offset: iconOffset,
        },
    ],
];

// Номер телефона можно передавать как строкой, так и массивом строк
const dataMap = [
    {
        id: 'select-ylist-1',
        name: 'Точка вывоза №1',
        isAvailable: true,
        coords: [55.745004, 37.622822],
        address: 'Кадашёвская набережная, 30',
        phone: ['8 (999) 999-99-99', '8 (961) 999-77-77'],
        workingTime: 'Круглосуточно',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-2',
        name: 'Точка вывоза №2',
        isAvailable: false,
        coords: [55.740066, 37.726063],
        address: 'Авиамоторная улица, 55к12',
        phone: '8 (999) 999-99-99',
        workingTime: '9:00-21:00',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-3',
        name: 'Точка вывоза №3',
        isAvailable: true,
        coords: [55.728124, 37.569736],
        address: 'Малая Пироговская улица, 15',
        phone: ['8 (999) 999-99-99', '8 (961) 999-77-77'],
        workingTime: '9:00-21:00',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-4',
        name: 'Точка вывоза №4',
        isAvailable: false,
        coords: [55.996872, 37.214897],
        address: 'Зеленоград, к322А',
        phone: '8 (999) 999-99-99',
        workingTime: 'Круглосуточно',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-5',
        name: 'Точка вывоза №5',
        isAvailable: true,
        coords: [55.911497, 37.730043],
        address: 'Мытищи, Московская область, улица Щербакова, 16',
        phone: ['8 (999) 999-99-99', '8 (961) 999-77-77'],
        workingTime: '9:00-23:00',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-6',
        name: 'Точка вывоза №6',
        isAvailable: false,
        coords: [55.790464, 37.530409],
        address: 'Ходынский бульвар, д. 4',
        phone: '8 (999) 999-99-99',
        workingTime: '8:30-21:00',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-7',
        name: 'Точка вывоза №7',
        isAvailable: true,
        coords: [55.861954, 37.687713],
        address: 'ул. Дудинка, д. 3',
        phone: ['8 (999) 999-99-99', '8 (961) 999-77-77'],
        workingTime: 'Круглосуточно',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-8',
        name: 'Точка вывоза №8',
        isAvailable: false,
        coords: [55.783944, 37.624642],
        address: 'Олимпийский проспект, д. 16, стр. 5, БЦ Олимпик-холл',
        phone: '8 (999) 999-99-99',
        workingTime: 'Круглосуточно',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-9',
        name: 'Точка вывоза №9',
        isAvailable: true,
        coords: [55.706431, 37.022618],
        address: 'Рублево-Успенское шоссе, пос. Горки-10, д. 24А',
        phone: ['8 (999) 999-99-99', '8 (961) 999-77-77'],
        workingTime: '9:00-22:00',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
    {
        id: 'select-ylist-10',
        name: 'Точка вывоза №10',
        isAvailable: true,
        coords: [55.451967, 37.763198],
        address: 'Советский пр-т, д. 2А',
        phone: '8 (999) 999-99-99',
        workingTime: 'Круглосуточно',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis illo perferendis quaerat.',
    },
];

const getAddress = address => `<p class="ylist-address">${address}</p>`;
const getDescription = description => `<p class="ylist-description">${description}</p>`;

/**
 * Рендерит информацию о выбранном магазине
 *
 * @param {Object} params — параметры из JSON
 */
const renderInfo = ({ address, phone, workingTime, description }) => {
    $('.js-selected-shop-info').html(`
        ${getAddress(address)}
        ${getMapPhoneNumber(phone)}
        ${getMapWorkingTime(workingTime)}
        ${getDescription(description)}
    `);
};

export default () => {
    let selectedShopId = 'select-ylist-3';
    const selectShop = ymapsInstance => {
        // скрываем все метки магазинов, кроме выбранного
        ymapsInstance.filter(currentObj => currentObj.id === selectedShopId);

        renderInfo(dataMap.find(currentObj => currentObj.id === selectedShopId));
    };

    // Карта выбранного магазина
    const selectedShopMap = new YMaps($('#selected-shop'));
    const mapOptions = {
        data: dataMap,
        dataOrder: ['name', 'address', 'phone', 'workingTime', 'description'],
        dataExtension: {
            // первый аргумент — свойство объекта метки
            // второй аргумент — сам объект метки, например phone(phoneNumber, pointData)
            // второй аргумент убрал, чтобы линтер не ругался
            address: getAddress,
            phone: getMapPhoneNumber,
            workingTime: getMapWorkingTime,
            description: getDescription,
        },

        map: {
            center: [55.751574, 37.573856],
            customize: {
                options: {
                    suppressMapOpenBlock: true,
                },
                controls: [
                    {
                        constructor: 'ZoomControl',
                        options: {
                            size: 'small',
                            position: {
                                top: 10,
                                right: 10,
                            },
                        },
                    },
                ],
            },
            /* container — необязательный параметр. Его сюда добавил, чтобы знали о такой возможности. Если его не передать, он возмется из шаблона.
            Передача может быть необходима в случае, если список будет жить отдельно от карты как независимый блок.
            Передать можно id (в данной версии не селектор! без решетки) */
            container: undefined,
            drag: {
                disableOnTouch: true,
                disableAlways: false,
            },
            dragTooltip: {
                text: 'Чтобы переместить карту, проведите по ней двумя пальцами',
            },
        },
        cluster: {
            icons: clusterIcons,
            inlineStyle: clusterCSS,
        },
        placemark: {
            icons: placemarkIcons,
        },
        balloon: {
            activeBeforeBreakpoint: true,
            activeAfterBreakpoint: true,
            closeButton: `<svg class="icon icon--cross"><use xlink:href="#icon-cross"></use></svg>`,
        },
        afterInit: selectShop,
    };

    // Карта списка магазинов
    const $mapBlock = $('#select-shop-list');

    if (!$mapBlock.length) console.error('Возможно забыли добавить попап с картой');

    const shopsListMap = new YMaps($mapBlock);
    const mapShopsListOptions = {
        data: dataMap,
        dataOrder: ['name', 'address', 'phone', 'workingTime', 'description', 'isAvailable'],
        dataExtension: {
            // первый аргумент — свойство объекта метки
            // второй аргумент — сам объект метки, например phone(phoneNumber, pointData)
            // второй аргумент убрал, чтобы линтер не ругался
            address: getAddress,
            phone: getMapPhoneNumber,
            workingTime: getMapWorkingTime,
            description: getDescription,
            isAvailable(isAvailable, { id }) {
                const isSelected = selectedShopId === id;

                if (isAvailable) {
                    return `
                        <button
                            class="btn btn--sm js-ylist-select-shop ylist-select-shop"
                            data-shop-id="${id}"
                            type="button"
                            ${isSelected ? 'disabled' : ''}>
                                ${isSelected ? 'Выбрано' : 'Забрать здесь'}
                        </button>
                    `;
                }

                return '<span class="ylist-message-fail">Нет в наличии</span>';
            },
        },

        map: {
            center: [55.751574, 37.573856],
            customize: {
                options: {
                    suppressMapOpenBlock: true,
                },
                controls: [
                    {
                        constructor: 'ZoomControl',
                        options: {
                            size: 'small',
                            position: {
                                top: 10,
                                right: 10,
                            },
                        },
                    },
                ],
            },
            /* container — необязательный параметр. Его сюда добавил, чтобы знали о такой возможности. Если его не передать, он возмется из шаблона.
            Передача может быть необходима в случае, если список будет жить отдельно от карты как независимый блок.
            Передать можно id (в данной версии не селектор! без решетки) */
            container: undefined,
            drag: {
                disableOnTouch: true,
                disableAlways: false,
            },
            dragTooltip: {
                text: 'Чтобы переместить карту, проведите по ней двумя пальцами',
            },
        },
        list: {
            header: true,
            active: true,
            scroll: false,
            /* container — необязательный параметр. Его сюда добавил, чтобы знали о такой возможности. Если его не передать, он возмется из шаблона.
            Передача может быть необходима в случае, если список будет жить отдельно от карты как независимый блок.
            Передать можно id (в данной версии не селектор! без решетки) */
            container: undefined,
            modifier: 'map-select__list',
            itemWrapper: 'ylist__shop-info',
            /* Собственный параметр dataOrder добавил в данном проекте, так как не всегда если
            необходимость добавилять в элемент списка сразу все элементы общего dataOrder
               Параметр необязательный */
            dataOrder: ['name', 'address', 'isAvailable'],
            // Элемент списка, на который навешивается обработчик клика
            clickElement: '.ylist-list__item:not(.is-active)',
        },
        cluster: {
            icons: clusterIcons,
            inlineStyle: clusterCSS,
        },

        /* switchContainer может быть как объектом, так и строкой.
        Если строка, передаем id.
        Если объект, то передаем 2 свойства: { id, type } */
        switchContainer: {
            /* Здесь по аналогии с options.list.container. id — необязательный параметр.
            Если он не передается, берется из шаблона */
            // id: 'id контейнера',
            /* Тип 'always' означает, что переключатель должен быть показан и на десктопе, и на смартфонах.
            Для данной карты в этом нет необходимости. Флаг стоит для информации */
            // type: 'always',
        },
        adaptiveBreakpoint: 1024,
        placemark: {
            icons: placemarkIcons,
        },
        balloon: {
            activeBeforeBreakpoint: true,
            activeAfterBreakpoint: true,
            closeButton: `<svg class="icon icon--cross"><use xlink:href="#icon-cross"></use></svg>`,
        },
        // afterInit(ylist, $mainContainer) {
        //     // сюда можно писать логику, которая выполнится после инициализации карты
        // },
    };

    // Если попап не проинициализирован, инициализируем
    const popupInstance = (() => {
        const $popupBlock = $mapBlock.closest('.popup');
        let popup = Popup.getInstance($popupBlock);

        if (!popup) {
            popup = new Popup($popupBlock);
            popup.init();
        }

        return popup;
    })();

    console.log(popupInstance);

    popupInstance.afterOpen(() => {
        if (!shopsListMap.$block.hasClass('is-loaded')) {
            shopsListMap.init(mapShopsListOptions);
        }
    });

    /**
     * Нажатие на кнопку выбора магазина
     */
    $(document).on('click', '.js-ylist-select-shop', ({ currentTarget }) => {
        const $button = $(currentTarget);
        selectedShopId = $button.attr('data-shop-id');

        selectShop(selectedShopMap);

        popupInstance.close();
    });

    // Функцию инициализации можем использовать после открытия нужного таба или попапа
    return () => {
        selectedShopMap.init(mapOptions);
    };
};
